import { ethers, BrowserProvider, Contract } from 'ethers';

import BoredApePixelClubV3 from "../assets/abi/BoredApePixelClubV3.json";
import { ABI, SMART_CONTRACT_ADDRESS } from './constants';

export async function getContract(provider: any): Promise<Contract | null> {
    if (!provider) return null;

    const contractAddress = SMART_CONTRACT_ADDRESS;
    const abi = ABI || BoredApePixelClubV3?.abi;

    // For BrowserProvider (connected wallet), use signer for write operations
    // For other providers (AlchemyProvider, etc.), use provider for read-only operations
    let signerOrProvider;
    if (provider instanceof BrowserProvider) {
        try {
            signerOrProvider = await provider.getSigner();
        } catch {
            signerOrProvider = provider;
        }
    } else {
        signerOrProvider = provider;
    }

    return new ethers.Contract(contractAddress, abi, signerOrProvider);
}
